import api from './api';

export const notificationService = {
  // Get all notifications
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.read !== undefined) {
      params.append('read', filters.read);
    }
    
    const response = await api.get(`/notifications?${params.toString()}`);
    return response.data;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data.unread_count;
  },

  // Mark notification as read
  markAsRead: async (id) => {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
  },

  // Mark all as read
  markAllAsRead: async () => {
    const response = await api.post('/notifications/read-all');
    return response.data;
  },

  // Delete notification
  delete: async (id) => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },
};
